import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import UseGetDashBoardData from "../../../../Components/Hooks/useDashboardData";
import UseGetDashBoardWithParams from "../../../../Components/Hooks/useDashboardDataParams";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-3 shadow-md rounded-md">
        <p className="font-bold text-xs">{label}</p>
        <p className="text-[#006A71] font-semibold text-xs">
          Open: {payload[0]?.value}
        </p>
        <p className="text-[#BF3131] font-semibold text-xs">
          Closed: {payload[1]?.value}
        </p>
      </div>
    );
  }
  return null;
};

const OverView = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [overviewData, setOverviewData] = useState([]);
  const [params, setParams] = useState({
   
    year: currentYear,
  });

  const { data, loading } = UseGetDashBoardWithParams(`/dashboard/ticket-status-overview`,params);

    useEffect(() => {
    if (data && Array.isArray(data)) {
      setOverviewData(data);
    }
  }, [data]);

   const handleYearChange = (e) => {
    const newYear = e.target.value;
    setParams({ ...params, year: newYear });
    setSelectedYear(newYear);
  };

  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg  flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-bold text-gray-800">Ticket Overview</h2>
        <select
            value={selectedYear}
            onChange={handleYearChange}
            className="border rounded-md p-1 text-xs text-[#ACACAC] font-normal"
          >
            {[...Array(10)].map((_, index) => (
              <option key={index} value={currentYear - 5 + index}>
                {currentYear - 5 + index}
              </option>
            ))}
          </select>
      </div>

      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={overviewData} barGap={4} barCategoryGap={10}>
          <XAxis dataKey="month" stroke="#666" tick={{ fontSize: 12 }}/>
          <YAxis stroke="#666"tick={{ fontSize: 12 }} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "none" }} />
          <Legend wrapperStyle={{ fontSize: "12px" }}/>
          <Bar
      dataKey="open"
      fill="#006A71"
      barSize={11}
      radius={[4, 4, 0, 0]}
      label={{ fontSize: 10, position: "top", fill: "#006A71" }} 
    />
    <Bar
      dataKey="closed"
      fill="#BF3131"
      barSize={11}
      radius={[4, 4, 0, 0]}
      label={{ fontSize: 10, position: "top", fill: "#BF3131" }}
    />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OverView;
